module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic-ext78.df55b7e.woff2";